import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 0;
  .ant-upload-select {
    display: block;
  }
  .error.ant-upload-wrapper .ant-upload-drag {
  }
`;
export const Button = styled.div`
  width: 100%;
  border-radius: 4px;
  border-width: 2px;
  border-style: dashed;
  border-color: ${({ $status }) => ($status ? "#ff4d4f" : "#d9d9d9")};
  padding: 40px;
  text-align: center;
  transition: all ease 300ms;
  .btn {
    margin-top: 8px;
    color: #d9d9d9;
  }
  &:hover {
    cursor: pointer;
    border-color: ${({ $status }) =>
      $status ? "#ff4d4f" : "var( --sidebar-item-active)"};
  }
`;
